import _ from 'lodash';
import request from 'superagent';
import * as types from '../actionTypes/irSearchActionTypes';
import * as docketsTypes from '../actionTypes/docketsActionTypes';
import { updateHasMoreRecentFilingDate } from './drupalDocketActions';


function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'PACER is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra,
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || [],
  };
}

function mapResponseToData(response, filters, searchType) {
  // todo check if other case menus return multiple types back like assoc cases
  let data = {};

  if (filters.type === 'associated_cases') {
    data = Array.isArray(response.body.queries)
      ? _.get(response.body, 'queries[0]', [])
      : _.get(response.body, 'queries', []);

    data = Object.keys(data).reduce((accum, next) => {
      accum.push([next, data[next][0].text]);
      return accum;
    }, []);
  } else {
    const type = searchType || filters.type;

    data = Array.isArray(response.body.queries)
      ? _.get(response.body, `queries[0].${type}[0].text`, [])
      : _.get(response.body, `queries.${type}[0].text`, []);
  }
  return data;
}

function receiveError(err) {
  const msg = mapResponseErrorsToMessage(err);
  return {
    type: types.SERVICE_ERROR,
    error: msg,
    errors: msg,
  };
}

function receiveCaseDataLocal(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: types.RECEIVE_CASE_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []),
    lastUpdated: _.get(response.body, `queries[0].${filters.type}[0].meta.timestamp`),
    receipt: null,
  };
}

function receiveCaseDataPurchased(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: types.RECEIVE_CASE_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []), // old
    lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
    receipt: _.get(response.body, 'items.receipts[0].text'),
  };
}

export function requestCaseData(params, dispatch) {
  dispatch({
    type: types.REQUEST_CASE_DATA,
    params,
  });

  dispatch({
    type: types.RESET_SERVICE_ERROR,
  });
}

export const getCaseData = params => function (dispatch) {
  requestCaseData(params, dispatch);
  dispatch({
    type: docketsTypes.UPDATE_DOCKET_HEADER,
    docketHeader: { hasMoreRecentFilingsDate: null },
  });

  return request
    .post('/ir-search/query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        dispatch(updateHasMoreRecentFilingDate(response));
        dispatch(receiveCaseDataLocal(response, params));
      },
      err => dispatch(receiveError(err)),
    );
};

export const purchaseCaseData = params => function (dispatch) {
  requestCaseData(params, dispatch);

  return request
    .post('/ir-search/pacer-query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        window.refresh_menu(params.case_uuid);

        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.queries)) {
          return dispatch(receiveError(response));
        }

        return dispatch(receiveCaseDataPurchased(response, params));
      },
      err => dispatch(receiveError(err)),
    );
};




// WEBPACK FOOTER //
// ./src/redux/actions/irSearchActions.js